import { useMemo, useRef } from "react"

import { Psychologist } from "utils/interfaces"
import { Analytics } from "utils/analytics"

export function usePlayedTimer(psy: Psychologist) {
    const playedSecondsRef = useRef(new Set<number>())
    const reportedRef = useRef(new Set<number>())
    return useMemo(
        () => ({
            track(time: number) {
                const summaryLength = playedSecondsRef.current.size
                if (summaryLength < 30) {
                    playedSecondsRef.current.add(Math.round(time))
                    if (summaryLength > 10 && !reportedRef.current.has(10)) {
                        reportedRef.current.add(10)
                        Analytics.audio_listened_10seconds({ psy })
                    }
                } else {
                    if (!reportedRef.current.has(30)) {
                        reportedRef.current.add(30)
                        Analytics.audio_listened_30seconds({ psy })
                    }
                }
            },
        }),
        []
    )
}
